import { useCallback, useEffect, useState } from 'react';
import { portfolioApi } from '../services/portfolioApi';
import { LEARNER_PORTFOLIO_STUB } from '../fixtures/portfolioStub';

// Backend V1 stub is live for GET /api/v1/users/portfolio. Hit it directly.
const USE_STUB = false;

export function useLearnerPortfolio() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (USE_STUB) {
        // Simulate a brief network delay so the loading state renders.
        await new Promise((r) => setTimeout(r, 120));
        setData(LEARNER_PORTFOLIO_STUB);
      } else {
        const res = await portfolioApi.getLearnerPortfolio();
        setData(res);
      }
    } catch (e) {
      setError(e?.message || 'Failed to load portfolio.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
}
